























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CmsDeserializer, GalleryPage } from '@/services/CmsDeserializer';

@Component
export default class Gallery extends Vue {
  @Prop({ required: true })
  public localPages: string;

  public currentPageIndex: number = 0;

  public get pages(): GalleryPage[] {
    return CmsDeserializer.parseGallery(this.localPages);
  }

  public get currentPage() {
    return this.pages[this.currentPageIndex];
  }

  public get pageCount() {
    return this.pages.length;
  }

  public goToPreviousPage() {
    if (this.currentPageIndex <= 0) {
      this.currentPageIndex = this.pageCount;
    } else {
      this.currentPageIndex--;
    }
  }

  public goToNextPage() {
    if (this.currentPageIndex >= (this.pageCount - 1)) {
      this.currentPageIndex = 0;
    } else {
      this.currentPageIndex++;
    }
  }

  public handleSwipe(direction: string) {
    if (direction === 'left') {
      this.goToNextPage();
    } else if (direction === 'right') {
      this.goToPreviousPage();
    }
  }
}
